var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checklist-album-upload"},[_c('attachments',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"label":"Загрузить фотографии","square":"","hide-list":"","source":_vm.source,"accepted-types":['.jpg', '.jpeg', '.png']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }